import { ApiEntity, IdKeyType } from "@hokuto/jam-core";
import {
  ApiErrorCause,
  JamAtlasParams,
  JamParams,
  JamMapParams,
} from "./types.js";

export function isMapParams(props: JamParams): props is JamMapParams {
  const keys = Object.keys(props);
  const values = Object.keys(props);
  return !!values[keys.indexOf(IdKeyType.Map)];
}

export function isAtlasParams(props: JamParams): props is JamAtlasParams {
  const keys = Object.keys(props);
  const values = Object.keys(props);
  return (
    !!values[keys.indexOf(IdKeyType.Atlas)] ||
    !!values[keys.indexOf(ApiEntity.Atlas)]
  );
}

export function isApiErrorCause(cause: unknown): cause is ApiErrorCause {
  if (!(cause instanceof Object)) return false;
  const keys = Object.keys(cause);
  const values = Object.values(cause);
  const text = values[keys.indexOf("text")];
  const status = values[keys.indexOf("status")];
  return cause instanceof Object && text && status;
}
